var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 1.94444H21L19 0H9L7 1.94444H0V5.83333H28M2 31.1111C2 32.1425 2.42143 33.1317 3.17157 33.861C3.92172 34.5903 4.93913 35 6 35H22C23.0609 35 24.0783 34.5903 24.8284 33.861C25.5786 33.1317 26 32.1425 26 31.1111V7.77778H2V31.1111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/IconTrash.c4914041c29361ae310fa651a6ea5626.svg";
export { ForwardRef as ReactComponent };